var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},_vm._l((_vm.menus),function(item,index){return (!item.auth || _vm.userInfo.group == item.auth)?_c('div',{key:index,staticClass:"item",class:{ active: _vm.active == item.id },on:{"click":function($event){return _vm.to(item)}}},[_c('i',{class:item.icon}),_vm._v(" "+_vm._s(item.name)+" ")]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }